// removed by extract-text-webpack-plugin
module.exports = {"videoWrapper":"src-components-simple-Video----style-module---videoWrapper---2e6xW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/simple/Video/style.module.css
// module id = 239
// module chunks = 168707334958949